import axios from 'axios'
import { NODE_BASE_URL, getAxiosOptions } from './serviceHelper'

export const timelineService = {
  getTimelineData: async (user, processReferenceNum, processTemplateId) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/timeline/${processTemplateId}/${processReferenceNum}`,
        getAxiosOptions(user)
      )
    ).data
  },
}
